<script setup lang="ts">
type Props = {
    /**
     * Titre de l'indicateur
     */
    name: string | undefined
    /**
     * Valeur de l'indicateur
     */
    value: string | number | null
    /**
     * Unité de l'indicateur
     */
    unit?: string
    /**
     * Icône de l'indicateur
     */
    icon?: string
    /**
     * Couleur de l'icône de l'indicateur
     */
    iconColor?: string
    /**
     * Couleur de la valeur de l'indicateur
     */
    textColor?: string
    /**
     * Tooltip de l'indicateur
     */
    tooltip?: string
    /**
     * Valeur affiché en cas de valeur null
     */
    defaultValue?: string
    /**
     * Affiche un effet de chargement
     */
    loading: boolean
}
withDefaults(defineProps<Props>(), {
    defaultValue: "-",
    textColor: "var(--p-primary-700)",
    tooltip: "",
    icon: "",
    iconColor: "var(--p-primary-500)",
    unit: "",
})

/*------------------------------------*/
/**             Computed              */
/*----------------------------------- */
</script>

<template>
    <div
        class="indicator-item flex flex-row items-center gap-6 min-w-[10.75rem] p-6 sm:p-3 sm:px-3 sm:min-w-auto bg-[var(--p-card-background)] border border-[var(--p-surface-300)] rounded-md hover:border-[var(--p-blue-500)]"
        v-if="!loading"
    >
        <!-- Icône -->
        <BaseIcon v-if="icon" :icon="icon" :color="iconColor" size="1.25rem" />
        <!-- Contenu -->
        <div class="indicator-item__wrapper flex flex-col gap-3">
            <!-- Wrapper Titre -->
            <div
                class="indicator-item__wrapper-title flex flex-row gap-2 items-center"
            >
                <!-- Titre -->
                <p class="indicator-item__title">{{ name }}</p>
                <!-- Tooltip -->
                <i
                    v-if="tooltip"
                    class="pi pi-info-circle"
                    style="font-size: 1rem; color: var(--p-primary-400)"
                    v-tooltip.top="{
                        value: tooltip,
                        pt: {
                            text: 'text-sm',
                        },
                    }"
                ></i>
            </div>
            <!-- Valeur -->
            <p
                class="indicator-item__value font-bold whitespace-nowrap"
                :style="{
                    color: textColor,
                }"
            >
                {{
                    value !== null && value !== undefined ? value : defaultValue
                }}
                <span v-if="unit">{{ unit }}</span>
                <slot name="value"></slot>
            </p>
        </div>
    </div>
    <div
        v-else
        class="indicator-item flex flex-row items-center gap-6 min-w-[10.75rem] p-6 sm:p-3 sm:px-3 sm:min-w-auto bg-[var(--p-card-background)] border border-[var(--p-surface-300)] rounded-md"
    >
        <BaseSkeleton width="1.25rem" height="1.25rem" />
        <div class="indicator-item__wrapper flex flex-col gap-3">
            <!-- Wrapper Titre -->
            <div
                class="indicator-item__wrapper-title flex flex-row gap-2 items-center"
            >
                <BaseSkeleton width="8rem" height="1rem" />
            </div>
            <!-- Valeur -->
            <BaseSkeleton width="8rem" height="1rem" />
        </div>
    </div>
</template>
